import React, { Component } from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import { injectIntl } from 'react-intl'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { ifLogbookConstant } from 'helpers/logbook'

class EventResultList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      evt_logbook_id: props.eventInfo.evt_logbook_id,
      previousValue: props.eventInfo.previous_value,
      value: props.eventInfo.value,
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.eventInfo !== nextProps.eventInfo) {
      this.setState({
        evt_logbook_id: nextProps.eventInfo.evt_logbook_id,
        previousValue: nextProps.eventInfo.previous_value,
        value: nextProps.eventInfo.value,
      })

      return false
    }

    return true
  }

  setResultId = ({ id }) => {
    this.setState({
      evt_logbook_id: id,
    })
  }

  onListChange = e => {
    this.setState(
      {
        value: e.target.value,
      },
      () => {
        this.props.onValueChange({
          ...this.props.eventInfo,
          value: this.state.value,
          evt_logbook_id: this.state.evt_logbook_id,
          setResultId: this.setResultId,
        })
      },
    )
  }

  render() {
    const {
      tabIndex,
      dataIndex,
      options,
      disabled,
      intl: { formatMessage },
    } = this.props
    const { value, previousValue } = this.state
    const checkValue = !value ? '' : value
    const checkPreviousValue = previousValue
      ? options[previousValue] || previousValue
      : ''

    return (
      <FormControl>
        {Boolean(!checkValue) && (
          <span className="select-placeholder">
            {ifLogbookConstant(formatMessage)(checkPreviousValue)}
          </span>
        )}

        <Select
          value={checkValue}
          onChange={this.onListChange}
          inputProps={{
            tabIndex,
            'data-index': dataIndex,
          }}
          className="event-result-field event-result-select"
          disabled={disabled}>
          {Object.keys(options).map((item, index) => (
            <MenuItem
              button
              key={index}
              value={
                // eslint-disable-next-line no-restricted-globals
                !isNaN(item) && Number.isInteger(parseFloat(item))
                  ? options[item]
                  : item
              }>
              {ifLogbookConstant(formatMessage)(options[item])}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
}

export default injectIntl(EventResultList)
